import React from 'react';
import { Header } from './common';
import { WhizzyLoader } from '../components';
import { SELECTOR_WIDTH } from '../util/vars';
import { useI18n } from '@whizz/react-i18n';

interface Props {
  /**
   * Prints an action at the center of the hear.
   */
  actionContent: React.ReactNode;
  /**
   * Displays loader.
   */
  isLoading: boolean;
  /**
   * Layout main content.
   */
  children: React.ReactNode;

  classId?: number;
}

const HomeLayout = ({ actionContent, isLoading, children, classId }: Props): JSX.Element => {
  const { translate } = useI18n();
  return (
    <div className={'w-full'}>
      <Header classId={classId}>
        <div className={'flex mx-auto'} style={{
          maxWidth: SELECTOR_WIDTH,
        }}>
          {actionContent}
        </div>
      </Header>
      <div className={'w-full mx-auto py-4 bg-white'}>
        <div className={'relative flex items-center justify-center max-w-screen-xl container'}>
          <div className={'p-1 border-b-4 border-header'}>
            <b className={'text-xl lg:text-2xl'}>{translate('global.ROUTES.HOME')}</b>
          </div>
        </div>
      </div>
      <div className={'max-w-screen-xl container mt-md mb-xl'}>
        <WhizzyLoader show={isLoading} />
        {!isLoading
          ? children
          : null
        }
      </div>
    </div>
  );
};

HomeLayout.displayName = 'HomeLayout';

export default HomeLayout;
